import { Star } from "lucide-react";
import SectionReveal from "./SectionReveal";
import googleG from "@/assets/google-g.svg";

const reviews = [
  {
    name: "Carol Parnell",
    initial: "C",
    color: "bg-[hsl(220,15%,40%)]",
    info: "1 review",
    time: "2 years ago",
    text: "John, from Banistean's Flooring first did a job for me and my husband in 2019 at our home. We hired him to install new hardwood flooring throughout the second level, and we had hardwood flooring installed for our staircase. We were overly satisfied with the work.",
  },
  {
    name: "Marcel Toma",
    initial: "M",
    color: "bg-[hsl(280,60%,45%)]",
    info: "1 review",
    time: "2 years ago",
    text: "I recently had the pleasure of working with Banistean's Flooring for the renovation of my flooring, and I must say that I am truly impressed with their exceptional service, craftsmanship, and attention to detail for a reasonable price.",
  },
  {
    name: "urban creativeplanners",
    initial: "U",
    color: "bg-[hsl(160,50%,40%)]",
    info: "1 review",
    time: "2 years ago",
    text: "I had the pleasure of working with John from Banistean's Flooring. John went above and beyond to get my house completed and under a week. Phenomenal pricing, amazing craftsmanship.",
  },
  {
    name: "LaTangela Jones",
    initial: "L",
    color: "bg-[hsl(25,90%,50%)]",
    info: "3 reviews",
    time: "2 years ago",
    text: "I recently inherited my grandparents old house, I wanted to redo the floors. I called John he gave me an unbeatable price. He was very punctual and went above and beyond to make sure I was satisfied with the services.",
  },
  {
    name: "Jade G",
    initial: "J",
    color: "bg-[hsl(45,80%,45%)]",
    info: "4 reviews · 2 photos",
    time: "2 years ago",
    text: "John was super helpful, knowledgeable and efficient at answering any questions I had. My floors look amazing and everything was left clean and tidy when they were done. Will definitely be recommending to others!",
  },
  {
    name: "Wally Szczebywlok",
    initial: "W",
    color: "bg-[hsl(0,0%,40%)]",
    info: "1 review",
    time: "2 years ago",
    text: "John did a fantastic job! The job was done promptly and with a very reasonable price.",
  },
];

const StarRating = () => (
  <div className="flex gap-0.5">
    {[...Array(5)].map((_, i) => (
      <Star key={i} className="w-4 h-4 fill-[hsl(45,100%,51%)] text-[hsl(45,100%,51%)]" />
    ))}
  </div>
);

const GoogleReviews = () => {
  return (
    <section className="py-16 lg:py-24 bg-muted">
      <div className="container mx-auto px-4 lg:px-8">
        <SectionReveal>
          <div className="flex items-center justify-center gap-3 mb-2">
            <img src={googleG} alt="Google" width={24} height={24} className="w-8 h-8" />
            <h2 className="text-3xl md:text-4xl font-heading font-bold">Google Reviews</h2>
          </div>
          <p className="text-center text-muted-foreground max-w-xl mx-auto mb-12">
            See what homeowners and business owners say about working with JTB Floors.
          </p>
        </SectionReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {reviews.map((review, i) => (
            <SectionReveal key={i} delay={i * 0.1}>
              <div className="bg-card border border-border rounded-xl p-6 h-full flex flex-col hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-center gap-3 mb-3">
                  <div className={`w-10 h-10 rounded-full ${review.color} flex items-center justify-center text-white font-bold text-sm flex-shrink-0`}>
                    {review.initial}
                  </div>
                  <div className="min-w-0">
                    <p className="font-semibold text-sm text-foreground truncate">{review.name}</p>
                    <p className="text-xs text-muted-foreground truncate">{review.info}</p>
                  </div>
                  <img src={googleG} alt="Google" width={24} height={24} className="w-5 h-5 ml-auto flex-shrink-0" />
                </div>
                <div className="flex items-center gap-2 mb-3">
                  <StarRating />
                  <span className="text-xs text-muted-foreground">{review.time}</span>
                </div>
                <p className="text-sm text-foreground/80 leading-relaxed flex-1">
                  {review.text}
                </p>
              </div>
            </SectionReveal>
          ))}
        </div>

        <SectionReveal delay={0.5}>
          <div className="text-center mt-10">
            <a
              href="https://maps.app.goo.gl/Tbt848wzbXLTv6nb7"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary hover:underline"
            >
              <img src={googleG} alt="Google" width={24} height={24} className="w-4 h-4" />
              See all reviews on Google
            </a>
          </div>
        </SectionReveal>
      </div>
    </section>
  );
};

export default GoogleReviews;
